module.exports = __webpack_public_path__ + "static/media/def1.204617c9.jpg";